<template>
  <div>
    <div class="qr-display">
      <div class="qrcode" ref="qrcode"></div>
    </div>
  </div>
</template>

<script>
import * as QRCode from "easyqrcodejs";
// Document: https://github.com/ushelp/EasyQRCodeJS#options

export default {
  props: {
    text: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    sub_title: {
      type: String,
      default: undefined,
    },
    size: {
      type: Number,
      default: 256,
    },
  },
  data() {
    return {
      result_qrcode: undefined,
      target_type: undefined,
      target_logo: "",
      target_title_length: 30,
      target_options: undefined,
      default_options: {
        text: "", //'https://cloud.agriweather.online/farm/reports?id=2WdKOm49NRvZNvGrVByD&lang=en',
        width: this.size,
        height: this.size,
        colorDark: "#106651",
        quietZone: 40,
        // quietZoneColor: 'rgba(223, 255, 128, 0.2)',//'#dfff80',
        titleTop: -12,
        titleFont: "bold 14px Taipei Sans TC",
        subTitleTop: parseInt(this.size) + 10,
        subTitleFont: "bold 12px Taipei Sans TC",
      },

      list_types: {
        line_group: {
          name: "Line Group",
          title: this.title,
          colorDark: "#4a2c6e",
          logoBackgroundTransparent: false,
          logoWidth: 35,
          logoHeight: 35,
          logo: this.$config.getAssetsURL("img/qrcode_icon.png"),
          quietZone: 20,
          titleTop: 0,
          titleFont: "bold 14px Taipei Sans TC",
          titleColor: "#000",
          titleHeight: 30,
          subTitleTop: 20,
          subTitleFont: "bold 14px Taipei Sans TC",
          subTitleColor: "#000",

          PO_TL: "#d6565b", // Posotion Outer color - Top Left
          PI_TL: "#d6565b", // Posotion Inner color - Top Left
          PO_TR: "#914164", // Posotion Outer color - Top Right
          PI_TR: "#914164", // Posotion Inner color - Top Right
          PO_BL: "#8e4065", // Posotion Outer color - Bottom Left
          PI_BL: "#8e4065", // Posotion Inner color - Bottom Left
        },
        default: {
          name: "Default",
          title: "AgriWeather",
          // title: '一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十',
          logoBackgroundTransparent: false,
          logoWidth: 120,
          logoHeight: 35,
          logo: this.$config.getAssetsURL("img/brand/logo5.png"),

          PO_TL: "#862d59", // Posotion Outer color - Top Left
          PI_TL: "#333399", // Posotion Inner color - Top Left
        },
      },
    };
  },
  mounted() {
    this.change_Type(this.type);
  },
  computed: {
    checkDisabled() {
      if (this.target_options.text == "") return true;
      if (this.target_options.text == undefined) return true;
      return false;
    },
  },
  watch: {
    size(val, oldVal) {
      if (typeof val == Number) {
        // console.log(`change size:${val}`);
        this.target_options.width = val;
        this.target_options.height = val;
        this.sub_title.subTitleTop = parseInt(val) + 10;
        this.create_prepare();
      }
    },

    text(val, oldVal) {
      this.create_prepare();
    },
    title(val, oldVal) {
      this.create_prepare();
    },
    sub_title(val, oldVal) {
      this.create_prepare();
    },

    type(val, oldVal) {
      this.change_Type(val);
    },

    target_type(val, oldVal) {
      this.create_prepare();
    },
  },
  methods: {
    create_prepare() {
      this.get_TypeSettings(this.target_type, this.default_options);

      if (this.checkDisabled == false) {
        this.create_QRCode();
      }
    },

    shorten_String(text, length = 10) {
      return text.slice(0, length) + (text.length > length ? "..." : "");
    },

    change_Type(type) {
      if (type && this.list_types[type]) {
        this.target_type = type;
      } else this.target_type = "default";
    },

    get_TypeSettings(type, options) {
      let _setting = this.list_types[type];
      let _options = { ...options, ..._setting };

      if (this.title != undefined)
        _options.title = this.shorten_String(
          this.title,
          this.target_title_length
        );
      else
        _options.title = this.shorten_String(
          _setting.title,
          this.target_title_length
        );

      if (this.sub_title != undefined)
        _options.subTitle = this.shorten_String(
          this.sub_title,
          this.target_title_length
        );

      if (this.text != undefined) _options.text = this.text;

      // console.log(_options);
      this.target_options = _options;
    },

    create_QRCode() {
      this.$refs.qrcode.innerHTML = "";
      this.result_qrcode = new QRCode(this.$refs.qrcode, this.target_options);
      // console.log( this.target_options )
      // console.log( this.result_qrcode )
      // console.log( this.$refs.qrcode )
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-display {
  // text-align: center;
  padding: 10px 0px;

  overflow-x: auto;
  overflow-y: hidden;
}
.qrcode {
  display: inline-block;
  padding: 5px;
  border-radius: 15px;
  background-color: white !important;
}
</style>
